import { get } from 'lodash'

export const addMonths = (date, months) => {
    const outputDate = new Date(date)

    if (Number.isNaN(outputDate.getTime())) {
        return null
    }

    const dayOfMonth = outputDate.getDate()

    outputDate.setMonth(outputDate.getMonth() + Number(months))
    if (outputDate.getDate() !== dayOfMonth) {
        outputDate.setDate(0)
    }

    return outputDate
}

export const getCurrentRunDate = recurrence => {
    return get(recurrence, 'dateNext') || get(recurrence, 'dateStarts') || get(recurrence, 'schedule.dateStarts')
}

export const getNextSkipDate = recurrence => {
    const currentRunDate = getCurrentRunDate(recurrence)

    return currentRunDate ? addMonths(currentRunDate, 1) : null
}
